import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { ALERT_TYPES, AlertDisplayCategory } from '@bringg/types';

import { CONFIG_TABLE_IDS } from '../../../../consts/index';
import { workflowsRootStore } from 'bringg-web/features/automation-workflows/stores/internal';

const useAlertOptions = (alertTypes: ALERT_TYPES[], tableId: CONFIG_TABLE_IDS) => {
	const { t } = useTranslation();
	const { workflowAlertsStore } = workflowsRootStore.getStore();

	const displayCategory = {
		[CONFIG_TABLE_IDS.EXCEPTIONS]: AlertDisplayCategory.TASK,
		[CONFIG_TABLE_IDS.DRIVER_ALERTS]: AlertDisplayCategory.DRIVER,
		[CONFIG_TABLE_IDS.OPTIMIZATION_ALERTS]: AlertDisplayCategory.OPTIMIZATION
	}[tableId];
	const configsByDisplayCategory = workflowAlertsStore.configurationsWithAlertByDisplayCategory[displayCategory];

	return useMemo(() => {
		const predefinedAlerts = alertTypes
			? alertTypes.map(type => ({
					value: type,
					label: t(`ALERT_TYPES.${ALERT_TYPES[type]}`)
			  }))
			: [];

		const customAlerts = configsByDisplayCategory.map(({ id, title }) => ({
			value: id,
			label: title || `<${t('EXCEPTIONS_LIST.ALERT')} ${id}>`
		}));

		return predefinedAlerts.concat(customAlerts);
	}, [t, alertTypes, configsByDisplayCategory]);
};

export default useAlertOptions;
